<template>
  <div>
    <i-dx-popup
      :popupVisible="popupVisible"
      :title="title"
      @popupCloseButtonClick="btnClose"
      height="98vh"
      max-height="100vh"
      width="98vw"
      max-width="100vw"
      :isCloseOnOutsideClick="false"
    >
      <template v-slot:grid>
        <div class="v-application" style="height: 100%; display: block !important; ">
          <v-row class="pa-5" style="height: calc(98vh - 158px)">
            <v-col cols="12" class="d-flex flex-column w-full h-full">
              <DxDataGrid
                ref="gridMain"
                :data-source="gridMain"
                width="100%"
                height="100%"
                key-expr="seq"
                :remote-operations="false"
                :hover-state-enabled="true"
                :allow-column-reordering="false"
                :allow-column-resizing="true"
                :row-alternation-enabled="true"
                :show-borders="true"
                :show-row-lines="true"
                :selection="{ mode: 'single' }"
                :focused-row-enabled="true"
                :paging="{ enabled: false }"
                :pager="{ visible: false }"
              >
                <DxScrolling mode="virtual" row-rendering-mode="virtual" :preload-enabled="true" :use-native="true" />
                <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
                <DxColumn width="60px" data-field="seq" caption="번호" alignment="center" data-type="string" :fixed="true" fixed-position="left" />
                <DxColumn
                  width="200px"
                  data-field="processNm"
                  data-type="string"
                  alignment="left"
                  caption="공정"
                  :fixed="true"
                  fixed-position="left"
                  :allow-editing="false"
                />
                <DxColumn
                  width="250px"
                  data-field="workNm"
                  data-type="string"
                  alignment="left"
                  caption="작업내용"
                  :fixed="true"
                  fixed-position="left"
                  :allow-editing="false"
                />
                <DxColumn
                  width="650px"
                  data-field="riskFactorContent"
                  data-type="string"
                  alignment="left"
                  caption="유해위험요인"
                  :allow-editing="false"
                />
                <DxColumn
                  width="600px"
                  data-field="riskReduceMeasuresContent"
                  data-type="string"
                  alignment="left"
                  caption="감소대책"
                  :allow-editing="false"
                />
              </DxDataGrid>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:footer>
        <div class="v-application">
          <v-row class="d-flex justify-end" style="gap: 12px; padding-right: 10px;">
            <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnApply">적용</v-btn>
            <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="btnClose">닫기</v-btn>
          </v-row>
        </div>
      </template>
    </i-dx-popup>
  </div>
</template>

<script>
// components
import IDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
// utils
// api
import { getReduceSample } from '@/api/riskAssessment/riskAssessmentOneCreation.js'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    selected: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  data() {
    return {
      gridMain: []
    }
  },
  watch: {},
  mounted() {},
  methods: {
    searchData(param) {
      //
      if (this.gridMain.length > 0) {
        return true
      }
      return new Promise((resolve, reject) => {
        getReduceSample(param, true)
          .then(response => {
            this.gridMain = response.list
            resolve(true)
          })
          .catch(error => {
            reject(false)
          })
      })
    },
    async btnApply() {
      const selectedRows = await this.GetDataGrid('gridMain').getSelectedRowsData()
      if (selectedRows.length == 0) {
        this.vSnackbar(this.$t('적용할 데이터가 없습니다.'), 'warn', 3000)
        return
      }

      const msg = '선택된 유해위험요인의 감소대책을 적용하시겠습니까?'
      this.vToastifyPrompt(msg, 'info', async current => {
        this.$emit('apply', selectedRows)
        this.GetDataGrid('gridMain').clearSelection()
      })
    },
    btnClose() {
      this.$emit('popupClose')
    }
  }
}
</script>

<style lang="scss" scoped></style>
